import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, PRIMARY_OUTLET } from "@angular/router";
import { IBreadcrumb } from "./edp-breadcrumb.model";

@Component({
    selector: "edp-breadcrumb",
    templateUrl: "./edp-breadcrumb.component.html",
    styleUrls: ["edp-breadcrumb.component.scss"],
})

export class EdpBreadcrumbComponent implements OnInit {
    public breadcrumbs: IBreadcrumb[];

    constructor(
        private activatedRoute: ActivatedRoute,
      ) {
        this.breadcrumbs = [];
      }

    ngOnInit() {
        const root: ActivatedRoute = this.activatedRoute.root;
        this.breadcrumbs = this.getBreadcrumbs(root);
    }

    private getBreadcrumbs(
        route: ActivatedRoute,
        routeURL: string = "",
        linkURL: string = "",
        breadcrumbs: IBreadcrumb[] = []): IBreadcrumb[] {
        const ROUTE_DATA_BREADCRUMB = "breadcrumb";
        const TRANSLATE_DATA_BREADCRUMB = "translate";
        const children: ActivatedRoute[] = route.children;

        if (children.length === 0) {
            return breadcrumbs;
        }

        for ( const child of children) {
            if (child.outlet !== PRIMARY_OUTLET) {
                continue;
            }

            if (!child.snapshot.data.hasOwnProperty(ROUTE_DATA_BREADCRUMB)) {
                return this.getBreadcrumbs(child, routeURL, linkURL, breadcrumbs);
            }

            const urlSnapshot: string = child.snapshot.url.map(segment => segment.path).join("/");
            routeURL += `/${urlSnapshot}`;

            /* Temporary solution to send to external link on customer-support case */
            if (routeURL === "/pedidos-apoio/") {
                linkURL = "/energia/apoio";
            } else {
                linkURL = null;
            }
            const breadcrumb: IBreadcrumb = {
                label: child.snapshot.data[ROUTE_DATA_BREADCRUMB],
                translate: child.snapshot.data[TRANSLATE_DATA_BREADCRUMB],
                params: child.snapshot.params,
                routeLink: routeURL,
                externalLink: linkURL,
            };

            if (child.snapshot.url.length > 0) {
                breadcrumbs.push(breadcrumb);
            }

            return this.getBreadcrumbs(child, routeURL, linkURL, breadcrumbs);
        }
        return breadcrumbs;
    }
}
